function OnScroll(counter) {
    this.counter = counter; // .class of the counter part
    this.countersStart = false;
    this.startCounting = function($elem) {
        if($elem.length > 0) {
            $elem.find('.counter').each(function() {
                var self = $(this);
                var elemText = self.html();
                self.html('');
                var countTo = parseInt( self.data('count-to') );

                var timeToEnd = 1000;
                var delay = 10;

                var isComma = /[0-9]+,[0-9]+/.test(countTo);
                if (isComma)
                    countTo = countTo.replace(/,/g, '');

                var divisions = timeToEnd / delay;
                var nums = [];

                for (var i = divisions; i >= 1; i--) {
                    // Preserve as int if input was int
                    var newNum = parseInt(countTo / divisions * i);

                    if (isComma) {
                        while (/(\d+)(\d{3})/.test(newNum.toString())) {
                            newNum = newNum.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                        }
                    }
                    nums.unshift(newNum);
                }

                // Updates the number until we're done - recourse oh yea!
                var f = function () {
                    var newNumber = parseInt( nums.shift() );
                    self.html(newNumber);
                    if (nums.length) {
                        setTimeout(f, delay);
                        if( newNumber == ( countTo - 1) ) {
                            setTimeout(function(){
                                self.html(elemText);
                            }, 100);
                        }
                    }
                };
                f() // Start the count up
            });
        }
    };

    this.hundleCounters = function() {
        var self = this
        if( self.counter.length > 0 ) {
            jQuery(window).scroll(function () {
                //hundle counters
                if(self.counter.length !== 0) {
                    if( !self.countersStart && jQuery(window).scrollTop() >= ( self.counter.offset().top - window.innerHeight )) {
                        self.countersStart = true;
                        self.startCounting(self.counter);
                        console.log('Start Counting')
                    }
                }
            });
        }
    };
    return this.hundleCounters();
}